'use strict';

var keyMirror = require('keymirror');

module.exports = {
	ActionTypes: keyMirror({
		TIPS_SEARCH_LOAD_DATA: null,
		TIPS_SEARCH_LOAD_DATA_SUCCESS: null,
		TIPS_SEARCH_LOAD_DATA_ERROR: null,
		TIPS_SEARCH_UPDATE_FILTERS: null,
		TIPS_SEARCH_SUBMIT_FORM: null,
		TIPS_SEARCH_CLEAR_FILTERS: null
	})
};